export { default as useFormattedCurrencyRates } from './useFormattedCurrencyRates';
